// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__17KkO","boxTitle":"Qualiphy_boxTitle__3syIi","box":"Qualiphy_box__1G35R","toggleWrap":"Qualiphy_toggleWrap__e0srh"};